import validate from "/app/50-ftd-20-frl-gllo/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/app/50-ftd-20-frl-gllo/middleware/redirect.global.js";
import manifest_45route_45rule from "/app/50-ftd-20-frl-gllo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}